import {
  IconApplicationStatusApprovalDocument,
  IconApplicationStatusCommission,
  IconApplicationStatusDecisionForming,
  IconApplicationStatusDraft,
  IconApplicationStatusExport,
  IconApplicationStatusImport,
  IconApplicationStatusIntakeCheck,
  IconApplicationStatusNgOffice,
  IconApplicationStatusNtpLocation,
  IconApplicationStatusRejectedCircle,
  IconApplicationStatusRevision,
  IconApplicationStatusSentToRzd,
  IconApplicationStatusSuccessCircle,
  IconApplicationStatusUserAssigned,
  IconApplicationStatusWarningTriangle,
  IconFileFill,
  IconPayment,
} from "@synthesis/shared-icons";
import { Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

import type { StatCardTableFilter } from "../applications-page.lib";

export type StatCardInfo = {
  filterKey: string;
  value: number;
  label: string;
  selectedBorderClass: string;
  iconClass: string;
  icon:
    | "file"
    | "intakeCheck"
    | "revision"
    | "ngOffice"
    | "ntpLocation"
    | "approvalDocument"
    | "userAssigned"
    | "commission"
    | "decisionForming"
    | "warningTriangle"
    | "export"
    | "import"
    | "draft"
    | "sentToRzd"
    | "wallet"
    | "successCircle"
    | "rejectedCircle";
  tableFilter: StatCardTableFilter;
};

const STAT_ICONS = {
  file: IconFileFill,
  intakeCheck: IconApplicationStatusIntakeCheck,
  revision: IconApplicationStatusRevision,
  ngOffice: IconApplicationStatusNgOffice,
  ntpLocation: IconApplicationStatusNtpLocation,
  approvalDocument: IconApplicationStatusApprovalDocument,
  userAssigned: IconApplicationStatusUserAssigned,
  commission: IconApplicationStatusCommission,
  decisionForming: IconApplicationStatusDecisionForming,
  warningTriangle: IconApplicationStatusWarningTriangle,
  export: IconApplicationStatusExport,
  import: IconApplicationStatusImport,
  draft: IconApplicationStatusDraft,
  sentToRzd: IconApplicationStatusSentToRzd,
  wallet: IconPayment,
  successCircle: IconApplicationStatusSuccessCircle,
  rejectedCircle: IconApplicationStatusRejectedCircle,
} as const;

type StatCardProps = {
  card: StatCardInfo;
  isSelected: boolean;
  onClick: () => void;
};

export const StatCard = ({ card, isSelected, onClick }: StatCardProps) => {
  const Icon = STAT_ICONS[card.icon];

  return (
    <Tooltip description={card.label} arrowAlign="center" arrowSide="bottom">
      <button
        type="button"
        onClick={onClick}
        className={cn(
          "flex min-w-[10.25rem] flex-1 shrink-0 cursor-pointer items-center gap-2 border-b-2 pb-2 pl-0.5 text-left transition-colors",
          isSelected ? card.selectedBorderClass : "border-neutrals-90",
        )}
      >
        <Icon className={cn("size-8 shrink-0", card.iconClass)} aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="subtitle-lg text-type-common">{card.value}</p>
          <p className="subtitle-sm text-type-minor truncate">{card.label}</p>
        </div>
      </button>
    </Tooltip>
  );
};
